// extracted by mini-css-extract-plugin
module.exports = {"sellPointsModule":"First_sellPointsModule__uL5k9"};